/*
 * @Author: wzh
 * @LastEditTime: 2023-07-31 14:12:23
 * @Description: 导出所有路由
 */

import homeRoutes from "./home.routes";
import authRoutes from "./auth.routes";
import authMobileRoutes from "./auth.mobile";
import mobileRouters from "./mobile.routers";
import ErrorRoutes from "./error.routes";
import { isMobile, redirectUriParams } from "@/utils/helpers";

let homeRedirect = null; // 跟路由重定向路由

// 七天免登录 Cookie 恢复已移至 main.js（Vue.use(VueCookies) 之后），避免插件未初始化时读不到 Cookie

let params = redirectUriParams();
if (Object.keys(params).includes("redirect_uri")) {
  homeRedirect = isMobile() ? "/mlogin" : "/authserver/login";
} else {
  homeRedirect = isMobile() ? "/mAuthServer" : "/authserver";
}
// else {
// 	homeRedirect = isMobile() ? "/mlogin" : "/authserver/login";
// }

// 根路由
const rootRoute = {
  path: "/",
  name: "root",
  redirect: homeRedirect,
  meta: {
    title: "首页", // 该标题勿修改，面包屑组件使用
  },
};

export default [rootRoute, ...homeRoutes, ...authRoutes, ...authMobileRoutes, ...mobileRouters, ...ErrorRoutes];
